import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

import type { EntityAccessLevel } from '../types/types';

export const ACCESS_LEVEL_LABEL = {
  write: 'edit',
  read: 'read',
  none: 'none',
} satisfies Record<EntityAccessLevel, string>;

export const ACCESS_LEVEL_BADGE_CLASS_NAMES = {
  write: 'border-[#bbf7d0] bg-[#f0fdf4] text-[#15803d]',
  read: 'border-[#bfdbfe] bg-[#eff6ff] text-[#1d4ed8]',
  none: 'border-[#e5e7eb] bg-[#f9fafb] text-[#9ca3af]',
} satisfies Record<EntityAccessLevel, string>;

export const ACCESS_LEVEL_TEXT_CLASS_NAMES = {
  write: 'text-[#15803d]',
  read: 'text-[#1d4ed8]',
  none: 'text-[#9ca3af]',
} satisfies Record<EntityAccessLevel, string>;

type AccessLevelBadgeProps = {
  access: EntityAccessLevel;
  className?: string;
};

export const AccessLevelBadge = ({ access, className }: AccessLevelBadgeProps) => {
  const { t } = useTranslation();
  const label = t(ACCESS_LEVEL_LABEL[access]);

  return (
    <span
      className={cn(
        'inline-flex w-14 items-center justify-center gap-1 rounded-[4px] border px-[6px] py-[2px] text-[10px] font-medium leading-[15px]',
        ACCESS_LEVEL_BADGE_CLASS_NAMES[access],
        className
      )}
    >
      <span aria-hidden="true" className="size-2 rounded-full bg-current" />
      {label}
    </span>
  );
};
